import { Empty } from '@byecode/ui'
import { getAssetUrl } from '@lighthouse/assets'
import type { IframeBlockAbstract } from '@lighthouse/core'
import { flexMinSizeStyle, getCursorStyle, getHttpUrl, useApplicationContext } from '@lighthouse/shared'
import React, { memo, useRef } from 'react'

import { useEffectiveAnchorId } from '../../context'
import { useScrollToAnchorWhenHashMatch } from '../../hooks/useScrollToAnchorWhenHashMatch'
import * as SC from './styles'

interface IframeBlockProps extends React.ComponentPropsWithoutRef<'div'> {
    value: string
    blockData: IframeBlockAbstract
}

const IframeBlock: React.FC<IframeBlockProps> = ({ value, blockData, style, ...rest }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null)
    const containRef = useRef<HTMLDivElement>(null)
    const { id, config, title } = blockData
    const { breakPoint, cursor, anchor } = config
    const { anchorId } = anchor || {}
    const effectiveAnchorId = useEffectiveAnchorId(anchorId)
    useScrollToAnchorWhenHashMatch(effectiveAnchorId, anchor)

    const { appId = '' } = useApplicationContext()

    const isEmpty = !value

    return (
        <SC.IframeContainer
            data-block-id={id}
            blockId={id}
            blockName={title}
            animation={breakPoint?.animation}
            id={effectiveAnchorId}
            ref={containRef}
            data-stop-action-propagation
            {...rest}
            style={{ ...flexMinSizeStyle, ...style, ...getCursorStyle(appId, cursor) }}
        >
            {isEmpty ? (
                <Empty
                    styles={{
                        root: {
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'var(--color-white)',
                            border: '1px solid var(--color-gray-200)',
                            borderRadius: 'inherit'
                        }
                    }}
                    icon={<SC.EmptyImg src={getAssetUrl('empty', 'no_iframe.svg')} alt="empty_iframe" />}
                    description="请在「右侧栏>配置」中填入网页链接"
                />
            ) : (
                <SC.Iframe ref={iframeRef} src={getHttpUrl(value)} allow="geolocation; fullscreen" allowFullScreen title={id} />
            )}
        </SC.IframeContainer>
    )
}

export default memo(IframeBlock)
